
// HOME PAGE ////////////

// Loader
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.classList.add("remove");
        }
    }, 1000);
});

// Initialize Lenis
const lenis = new Lenis({
    autoRaf: true,
});

lenis.on('scroll', (e) => {
    console.log(e);
});

// Mobile Lenis close code/////
if (window.innerWidth > 1024) {
  // init Lenis
}

// RESPONSIVE MENU ENTRY JS
jQuery('.ham-menu-btn a').click(function(){
	jQuery('.responsive-menu').addClass('active');
    jQuery('body').addClass('stop-scroll');
});
// RESPONSIVE MENU EXIT JS
jQuery('.respon-cross a').click(function(){
	jQuery('.responsive-menu').removeClass('active');
    jQuery('body').removeClass('stop-scroll');
});
// RESPONSIVE MENU UL TOGGLE JS
jQuery(document).ready(function () {
    jQuery('.responsive-links ul li > a').click(function (e) {
        if (jQuery(this).siblings('ul').length > 0) {
            e.preventDefault();
            e.stopPropagation();
            
            jQuery('.responsive-links ul li > a').not(this).siblings('ul').slideUp();
            jQuery('.responsive-links ul li > a').not(this).parent().removeClass('active');

            jQuery(this).siblings('ul').slideToggle();
            jQuery(this).parent().toggleClass('active');
        }
    });
});

//  myProject SLIDER JS
var swiper = new Swiper(".myProject2", {
  slidesPerView: 4,
  slidesPerGroup: 4,   // ek click par poora set move ho
  grid: {
    rows: 2,
    fill: "row",
  },
  spaceBetween: 22,
  loop: false,
  speed: 1000,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    slideChangeTransitionEnd: function () {
      AOS.refresh();
    }
  },

  breakpoints: {
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      grid: {
        rows: 2,
      },
    },

    992: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      grid: {
        rows: 2,
      },
    },

    768: {
      slidesPerView: 2,
      slidesPerGroup: 1,
      grid: {
        rows: 1,
      },
    },

    0: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      grid: {
        rows: 1,
      },
    }
  }
});

// TESTIMONIAL SLIDER JS
var swiper = new Swiper(".my-testi", {
  loop: true,
  spaceBetween: 15,

  slidesPerView: 3,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    // ≤ 767px (Mobile)
    0: {
      slidesPerView: 1,
      centeredSlides: true,
    },

    // ≥ 768px and ≤ 991px (Tablet)
    768: {
      slidesPerView: 2,
      centeredSlides: false,
    },

    // ≥ 992px (Desktop)
    992: {
      slidesPerView: 3,
      centeredSlides: false,
    }
  }
});

// === SEARCH POPUP JS ===
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openSearch");
  const closeBtn = document.getElementById("closeSearch");
  const overlay = document.getElementById("searchOverlay");

  if (openBtn && closeBtn && overlay) {
    // Open popup
    openBtn.addEventListener("click", () => {
      overlay.classList.add("active");
      document.body.style.overflow = "hidden"; // prevent scroll
      setTimeout(() => {
        overlay.querySelector(".search-input").focus();
      }, 200);
    });

    // Close popup
    closeBtn.addEventListener("click", () => {
      overlay.classList.remove("active");
      document.body.style.overflow = "";
    });

    // Close on overlay click
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        overlay.classList.remove("active");
        document.body.style.overflow = "";
      }
    });

    // Close on ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        overlay.classList.remove("active");
        document.body.style.overflow = "";
      }
    });
  }
});

////////  Contact Us ////////

document.addEventListener("DOMContentLoaded", function () {

  setTimeout(function () {  // <<< DELAY FIXES EVERYTHING

    const overlay = document.querySelector(".thankyou-overlay");
    const closeBtn = document.getElementById("close-popup");

    const formSubmitted =
      window.location.search.includes("contact_posted=true") ||
      window.location.hash.includes("contact-form");

    console.log("Form Submitted? →", formSubmitted);

    if (formSubmitted) {
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
    }

    closeBtn.addEventListener("click", function () {
      overlay.classList.remove("active");
      document.body.style.overflow = "";

      const cleanURL = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanURL);
    });

  }, 50); // <<< HASH FULLY AVAILABLE AFTER 30–50ms ON SHOPIFY

});

var swiper = new Swiper(".myProject", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    speed: 1000,
    breakpoints: {
        1550: {
            slidesPerView: 4,
            spaceBetween: 22,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 22,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        356: {
            slidesPerView: 1,
            spaceBetween: 10,
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
  var sliderEl = document.querySelector(".relatedproduct");
  if (!sliderEl) return;

  var slidesCount = sliderEl.querySelectorAll(".swiper-slide").length;

  var slidesPerView = 4; // default, aap settings ke hisab se adjust kar sakte ho

  // Initialize Swiper
  var relatedSwiper = new Swiper(".relatedproduct", {
    slidesPerView: slidesPerView,
    spaceBetween: 22,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 2 },
      768: { slidesPerView: 2 },
      0: { slidesPerView: 1 },
    },
  });

  // ✅ Conditional arrows display
  var prevBtn = sliderEl.querySelector(".swiper-button-prev");
  var nextBtn = sliderEl.querySelector(".swiper-button-next");

  if (slidesCount <= slidesPerView) {
    if (prevBtn) prevBtn.style.display = "none";
    if (nextBtn) nextBtn.style.display = "none";
  } else {
    if (prevBtn) prevBtn.style.display = "";
    if (nextBtn) nextBtn.style.display = "";
  }
});
